export const SEARCH_CHANGE_TIMES = 'search-change-times';

const changeTimes = ({ startTime, endTime }) => ({ type: SEARCH_CHANGE_TIMES, payload: { startTime, endTime, searchType: 'bounds' } });

export default changeTimes;
